import React from "react";
import ItemCategoryNav from "./ItemCategoryNav";

const ShopFilters = ({categoryTree, itemCategoryId, onSelectCategory, propertyGroups, selectedPropertyValueIds, onTogglePropertyValue}) => (
    <div className="space-y-6">
        <div>
            <h2 className="font-semibold text-gray-700 mb-2">Kategorien</h2>
            <ItemCategoryNav
                tree={categoryTree}
                selectedCategoryId={itemCategoryId}
                onSelect={onSelectCategory}
            />
        </div>

        {propertyGroups.map((group) => (
            <div key={group.name}>
                <h2 className="font-semibold text-gray-700 mb-2">{group.name}</h2>
                <ul className="space-y-1">
                    {group.values.map(({itemPropertyValueId, value}) => (
                        <li key={itemPropertyValueId}>
                            <label className="flex items-center text-sm text-gray-700 cursor-pointer">
                                <input
                                    type="checkbox"
                                    className="mr-2"
                                    checked={selectedPropertyValueIds.includes(itemPropertyValueId)}
                                    onChange={() => onTogglePropertyValue(itemPropertyValueId)}
                                />
                                {value}
                            </label>
                        </li>
                    ))}
                </ul>
            </div>
        ))}
    </div>
);

export default ShopFilters;
